import { ActivatedRoute } from '@angular/router';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';

import { CmsBlogSearchComponentClass } from 'lib/components/cms/blog/cms-blog-search-component.class';
import { CmsService } from 'lib/services/cms.service';
import { InfiniteScrollService } from 'lib/services/infinite-scroll.service';
import { MetaService } from 'lib/services/meta.service';
import { calculateReadingTime } from 'lib/tools';

@Component({
    selector: 'app-cms-blog-search',
    templateUrl: './cms-blog-search.component.html',
    styleUrls: ['./cms-blog-search.component.scss'],
    standalone: false,
})
export class CmsBlogSearchComponent extends CmsBlogSearchComponentClass implements OnInit {
    calculateReadingTime: (entry: any) => string;
    constructor(
        @Inject(PLATFORM_ID) platformId: Object,
        @Inject('environment') environment: any,
        activatedRoute: ActivatedRoute,
        cmsService: CmsService,
        infiniteScrollService: InfiniteScrollService,
        metaService: MetaService
    ) {
        super({
            dependencies: {
                platformId,
                activatedRoute,
                cmsService,
                environment,
                infiniteScrollService,
                metaService,
            },
        });
        this.type = 'search';
        this.calculateReadingTime = calculateReadingTime;
    }
}
